import { FC, useRef } from "react";
import { Button } from "@mui/material";

import { TestimonialCard } from "../../molecules";
import { TestimonialEntity } from "../../../store";

export const Testimonials: FC<{ data: TestimonialEntity[] }> = ({ data }) => {
  const pageRef = useRef<number>(1);
  const changePage = () => {
    pageRef.current += 1;
  };
  return (
    <div className="min-w-screen px-2 lg:px-6 space-y-6">
      <div className="space-y-1">
        <h1 className="pageTitle">Happy customers</h1>
        <p className="text-sm text-gray-500">What our customers say about us</p>
      </div>
      {data && (
        <div className="flex flex-col items-center gap-8">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-x-4 gap-y-12">
            {data?.map((item, index) => {
              const { customerName, imageUrl, testimonial, productUrl } = item;
              return (
                <TestimonialCard
                  key={index}
                  customerName={customerName}
                  imageUrl={imageUrl}
                  testimonial={testimonial}
                  productUrl={productUrl}
                />
              );
            })}
          </div>
          <Button
            onClick={changePage}
            disabled={data.length > 290}
            color="secondary"
            variant="outlined">
            Load more
          </Button>
        </div>
      )}
    </div>
  );
};
